import React from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import PageLevelMessage from 'src/common/refactoredComponents/pageLevelMessage';
import { Container, ButtonContainer } from './AssignTerritorySuccess.styled';
import SuccessTickIcon from 'src/assets/images/success_tick.svg';
import { 
    LARGE_TEXT_PX, 
    BASE_TEXT_PX,
    FONT_FAMILY_DEMI 
} from 'src/styles/fonts/MCFontConstants.js';

const AssignTerritorySuccess = ({ 
    orderNumber, 
    selectedTerritories={},
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <Popup
            id="orders-assignterritorySuccess-popup"
            title={t('orders.assignTerritorySuccess.title')}
            onClose={onClose}
            width="90%"
            webWidth="450px"
            borderRadius="6px"
            popupContentPadding="10px 15px"
            mobileWidthPercent={'96%'}        
        >
            <Container>
                <PageLevelMessage
                    status="reportIssue"
                    message={t('orders.assignTerritorySuccess.territoryAssigned')}
                    successMessage={t('orders.assignTerritorySuccess.successMessage', {
                        orderNumber: orderNumber || '',
                        territoryName: selectedTerritories?.salesRepNonInterName || selectedTerritories?.salesRepInterName,
                        interpolation: { escapeValue: false }
                    })}
                    imgSrc={SuccessTickIcon}
                    imgHeight="28px"
                    imgWidth="28px"
                    imageContainerWidth="57px"
                    headerFontSize={LARGE_TEXT_PX}
                    messageFontSize={BASE_TEXT_PX}
                    isFromReportIssue={true}
                    marginTop="20px"
                    boxShadow={'0px 0px 6px rgba(0,0,0,0.20)'}
                />
                
                <ButtonContainer>
                    <Button
                        id="orders-assignterritorySuccess-close-button"
                        show
                        variant={ButtonStyles?.primary}
                        width="120px"
                        minWidth="120px"
                        height="40px"
                        fontSize={BASE_TEXT_PX}
                        borderRadius="1600px"
                        fontFamily={FONT_FAMILY_DEMI}
                        clicked={onClose}
                    >
                        {t('common.closeButton')}
                    </Button>
                </ButtonContainer>
            </Container>
        </Popup>
    );
};

export default AssignTerritorySuccess;
